<div *ngIf="routeLoading; else verification" fxFlex fxLayout="column" fxLayoutAlign="center center" class="card">
  <div class="logo">
  </div>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<ng-template #verification>
  <ng-container *ngIf="invitationError; else codeEntry">
    <app-invitation-error></app-invitation-error>
  </ng-container>
  <ng-template #codeEntry>
    <div class="flex-container container" fxLayout="row">
      <div *ngIf="!isBaskBrand" fxflex="20" [fxLayoutAlign]="isBaskBrand ? 'center start' : 'center center'" class="left-sidebar"></div>
      <div fxflex="80" class="right-sidebar">
        <div class="page-content">
          <div class="subtitle">{{title}}</div>
          <div id="description" class="center" *ngIf="!error">{{description}}</div>
          <div class="boxedValidation" *ngIf="error" [innerHTML]="error"></div>
          <br>
          <form [formGroup]="accessCodeForm">
            <div>
              <mat-form-field appearance="outline">
                <input matInput class="input-text" type="text" formControlName="accessCode"
                       maxlength="8">
                <mat-error *ngIf="accessCode?.hasError('required')">Please enter one time access code</mat-error>
                <mat-error *ngIf="accessCode?.hasError('minlength') || accessCode?.hasError('maxlength')">Please enter valid one time access code</mat-error>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxLayoutAlign="center center">
              <ng-container *ngIf="!isBaskBrand && !hideResendButton">
                <button id="resendButton" (click)="onGenerateClick($event)" mat-button>Re-send Access Code</button>
              </ng-container>
              <ng-container *ngIf="!(facade.isMobile$ | async)">
                <br>
              </ng-container>
              <div fxFlex="100" fxLayoutGap="20" fxLayout="row" [fxLayout.lt-sm]="isBaskBrand? 'column' : 'row'" fxLayoutAlign="space-around center"
                   [fxLayoutAlign.lt-sm]="isBaskBrand? '' : 'space-around center'" class="row">
                <button [ngClass]="{ 'submit-btn': !isBaskBrand }" mat-stroked-button class="secondary-btn-action" color="primary"
                        (click)="cancel()" type="button" [fxFlexOrder.lt-md]="isBaskBrand? 1 : 0">CANCEL
                </button>
                <button [ngClass]="{ 'submit-btn': !isBaskBrand }" [disabled]="loading" mat-flat-button class="primary-btn-action" color="primary"
                        type="submit"
                        [class.spinner]="loading" (click)="verify()" [fxFlexOrder.lt-md]="isBaskBrand? 0 : 1">VERIFY
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ng-container *ngIf="!isBaskBrand; else isTcbBrand">
        <div class="start-image-container">
          <img mat-card-image src="{{imagePath}}" alt="star image">
        </div>
      </ng-container>
      <ng-template #isTcbBrand>
        <img src="/assets/images/bask/shield.png" class="bask-shield" alt="Bask code verification.">
      </ng-template>
    </div>
  </ng-template>
